import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UnitsService } from 'src/app/core/services/units.service';
import { TimerService } from 'src/app/services/timer.service';

@Component({
  selector: 'app-create-timer',
  templateUrl: './create-timer.component.html',
  styleUrls: ['./create-timer.component.scss'],
})
export class CreateTimerComponent implements OnInit {
  timerForm: FormGroup;
  alertTypes = [
    { code: '03', valor: 'Alerta en proceso' },
    { code: '02', valor: 'Alerta rechazada' },
  ];
  timeScales = ['seg', 'min', 'hora'];
  units = [];
  unitsSelected = [];

  constructor(
    private fb: FormBuilder,
    private unitsService: UnitsService,
    public dialogRef: MatDialogRef<CreateTimerComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private timerService: TimerService
  ) {}

  ngOnInit() {
    console.log(this.data);

    // this.unitsSelected = this.data?.unit.map((unit) => unit._id);
    // Inicializar el formulario
    this.timerForm = this.fb.group({
      nombre: [this.data?.nombre || '', Validators.required],
      tipo_alerta: [this.data?.tipo_alerta || '', Validators.required],
      unit: [this.data?.unit[0]._id || '', Validators.required],
      escala: [this.data?.escala || '', Validators.required],
      valor: [this.data?.valor || '', [Validators.required, Validators.min(0)]],
    });

    // Cargar las unidades desde el servicio
    this.unitsService.getAll().subscribe({
      next: (units) => {
        this.units = units;
      },
      error: (err) => {
        console.error('Error al cargar las unidades:', err);
      },
    });
  }

  saveTimer() {
    // this.timerForm.value.unit = this.unitsSelected;
    if (this.timerForm.valid) {
      if (this.data) {
        this.timerForm.value.unit = [this.timerForm.value.unit];
        this.timerService
          .updateTimer(this.data._id, this.timerForm.value)
          .subscribe({
            next: (response) => {
              console.log(response);

              this.dialogRef.close(response);
            },
            error: (err) => {
              console.error('Error al actualizar el temporizador:', err);
            },
          });
      } else {
        this.timerService.createTimer(this.timerForm.value).subscribe({
          next: (response) => {
            this.dialogRef.close(response);
          },
          error: (err) => {
            console.error('Error al crear el temporizador:', err);
          },
        });
      }
    } else {
      console.error('Formulario inválido');
    }
  }
  close() {
    this.dialogRef.close();
  }
}
